export default function ScholarmapsIcon({size=50}:{size?:number}){
    return <img src={"/logowide.png"} style={{"height":size+"px"}}></img>
}